module.exports = __webpack_public_path__ + "static/media/icc_katapatjar.168160c4.png";